module.exports = __webpack_public_path__ + "img/train-3.71a79f16.jpg";